<template>
    <div class="modal-content card dashboardGuidedTour">
        <div class="card-content">
            <h1 class="title is-2">Welcome to Your <span>New</span> Dashboard</h1>

            <section class="dashboardGuidedTour__description mt-2 has-text-centered">
                <p>
                    Customize your learning experience! You can change these selections later by clicking the
                    <strong>"Customize Your Experience"</strong> button on your dashboard.
                </p>
            </section>
        </div>

        <div class="card-footer align-items-end">
            <div class="card-footer-item">
                <a href="#" @click.prevent="$emit('next')">
                    <icon-text icon="angle-right" position="is-right" class="is-mobile" dense>Next</icon-text>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import IconText from '@/components/IconText.vue';

export default {
    name: 'DashboardGuidedTourStepOne',

    components: { IconText },

    emits: ['next'],
};
</script>
